"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellMarginsDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../../base-utils/map-creator");
var destination_1 = require("../../../destination");
var width_unit_destination_1 = require("../../width-unit-destination");
var TableCellMarginsDestination = (function (_super) {
    tslib_1.__extends(TableCellMarginsDestination, _super);
    function TableCellMarginsDestination(data, properties, descriptors) {
        var _this = _super.call(this, data) || this;
        _this.descriptors = descriptors;
        _this.properties = properties;
        return _this;
    }
    Object.defineProperty(TableCellMarginsDestination.prototype, "elementHandlerTable", {
        get: function () {
            return new map_creator_1.MapCreator()
                .add('top', this.getHandler(this.descriptors.top))
                .add('left', this.getHandler(this.descriptors.left))
                .add('start', this.getHandler(this.descriptors.left))
                .add('bottom', this.getHandler(this.descriptors.bottom))
                .add('right', this.getHandler(this.descriptors.right))
                .add('end', this.getHandler(this.descriptors.right))
                .get();
        },
        enumerable: false,
        configurable: true
    });
    TableCellMarginsDestination.prototype.getHandler = function (desc) {
        var props = this.properties;
        return function (data) { return new width_unit_destination_1.WidthUnitDestination(data, desc.getProp(props), function () { return props.setValue(desc, desc.getProp(props)); }); };
    };
    return TableCellMarginsDestination;
}(destination_1.ElementDestination));
exports.TableCellMarginsDestination = TableCellMarginsDestination;
